<template>
  <div style="background-color:white" >
    <app-header></app-header>
    <div >
      <div style="width:100%;margin:15px">
       <el-row style="height:25%; background-color:gray"></el-row>
       <div class="container">
        <h1 class="section-title">Appels d'offres
           
        </h1>

        <el-card class="box-card" v-for="offre in appels_offre" :key="offre.id" style="border-bottom: 2px solid #ccc;">
          <div slot="header" class="clearfix">
            <span style="font-size:2em; font-weight:bold">{{offre.titre}}</span>
            <el-button style="float: right; padding: 3px 0" type="text">Afficher les details</el-button>
          </div>
          <div class="description-overview">
            {{offre.description.slice(0,offre.description.length/4)}}....
          </div>
         <hr>
        <el-row>
          <div  align="right" style="font-weight:bold;font-size:1.3em">
            <el-col :span="20" style="font-weight:bold">Contact</el-col>
            
            <el-col :span="4" right>{{offre.contact}}</el-col>
          </div>
        </el-row>
        </el-card>
       </div>
      </div>
  
    </div>
   
    
  <el-container>
    <el-footer style="background-color:#000;height:200px"></el-footer>
  </el-container>
  </div>

</template>

<script>
import {mapState, mapActions} from 'vuex'
import AppHeader from "../../containers/AppHeader";


export default {
  name: 'Home',
  components:{
    AppHeader
  },
  data(){
    return {
      
    }
  },
  computed:{
    ...mapState({
     appels_offre:state=>state.offres.appels_offre
   })
  },
  methods:{
    ...mapActions([
      'getAppelOffre'
    ])
  },
  created(){
    this.getAppelOffre();
  }
}
</script>

<style scoped> 


  .container h1{
    font-weight: bold;
    margin-top: 80px;
    margin-bottom: 30px;
    padding-bottom: 3px;
    border-bottom: 2px solid #ccc;
    font-size:4em;
    color:#000
  }
</style>
